









































































































import { defineComponent, reactive, toRefs, onMounted, watch } from '@vue/composition-api';
import * as ExcelJS from 'exceljs';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SumupListCondition, SumupGroup } from "../../modules/teacher/PracticeSumupList"


export interface Data {
  condition: SumupListCondition
  sumupGroups: SumupGroup[]
  fields: any[]
  totalCount: number
  isAllCheckedDelete: boolean
  errors: string[]
  isShow: boolean
  progress: string
  isDispProgress: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.sumupListCondition,
      sumupGroups: new Array<SumupGroup>(),
      fields: [
        {key: "id", label: "集計ID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "exec_date", label: "実施日", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "試験名", sortable: true, class: 'text-center b-table-th-td'},
      ],
      totalCount: 0,
      isAllCheckedDelete: false,
      errors: [],
      progress: "0.0",
      isDispProgress: false,
      isShow: false
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/practice_sumup_list?${Common.BuildQuery(state.condition, 'search_condtion')}`).then(response => {
        state.sumupGroups = response.data.sumup_groups.map((x: any) => new SumupGroup(x));
        context.root.$store.commit("setSumupListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * 採点状態文言にコンバート
     ******************************/

    const convertSaitenCompleted = (saitenCompleted: boolean) => {
      return saitenCompleted ? "採点完了" : "未完了";
    }

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SumupListCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      context.root.$store.commit("setSumupListCondition", state.condition);
    };

    /******************************
     * 集計マスタ追加ボタン押下
     ******************************/

    const addSumupGroupClick = () => {
      context.root.$router.push('/teacher_site/practice_sumup_edit/new').catch(err => {});
    };

    /******************************
     * 設定ボタン押下
     ******************************/

    const sumupEditClick = (id: number) => {
      context.root.$router.push(`/teacher_site/practice_sumup_edit/${id}`).catch(err => {});
    };

    /******************************
     * 統計ボタン押下
     ******************************/

    const sumupDetailClick = (id: number) => {
      context.root.$store.commit("setSumupDetailCurriculumId", 0);
      context.root.$router.push(`/teacher_site/practice_sumup_detail_total/${id}`).catch(err => {});
    }

    /******************************
     * 一覧ボタン押下
     ******************************/

    const sumupResultRankClick = (id: number) => {
      context.root.$store.commit("setSumupResultCurriculumId", 0);
      context.root.$router.push(`/teacher_site/practice_sumup_result_rank_list_total/${id}`).catch(err => {});
    }

    /******************************
     * 削除列ヘッダーCheckBoxの監視
     ******************************/

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {
      state.sumupGroups.forEach(x => x.isSelected = newVal);
    });


    /******************************
     * 削除アイコン押下
     ******************************/

    const sumupGruoupDelete = async () => {

      state.errors = []

      const ids = state.sumupGroups.filter(x => x.isSelected).map(x => x.id);

      if(ids.length == 0){
        state.errors.push("削除対象が選択されていません。");
      }

      if (!window.confirm('集計マスタを削除します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_list/sumup_groups_destroy`, {ids: ids}).then(response => {
        alert("処理が完了しました。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 集計アイコン押下
     ******************************/

    const sumupClick = async (sumup_group_id: number) => {

      if (!window.confirm('集計を実行します。既に集計済みのデータがある場合は上書きされます。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_list/sumup/${sumup_group_id}`).then(response => {
        alert("処理が完了しました。");
        state.errors = [];
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 採点結果DLアイコン押下
     ******************************/

    const downloadClick = async (sumup_group_id: number) => {
      if (!window.confirm('採点結果ファイルをダウンロードします。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/teacher/practice_sumup_list/download/${sumup_group_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `result_${sumup_group_id}.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 採点内容DLアイコン押下
     ******************************/

    const downloadExcelClick = async (sumupGroup: SumupGroup) => {
      if (!window.confirm('採点内容エクセルファイルをダウンロードします。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const curriculum_ids: number[] = sumupGroup.curriculum_count == 2 ? [1, 2] : [1, 2, 5, 4];

      for(const curriculum_id of curriculum_ids) {
        await http.get(`/api/teacher/practice_sumup_list/download_excel/${sumupGroup.id}/${curriculum_id}`, {responseType: 'arraybuffer'}).then(response => {
          const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `saiten_result_${sumupGroup.name}_${context.root.$store.getters.getCurriculumNameById(curriculum_id)}.xlsx`;
          a.click();
        })
        .catch(error=>{
          if(error.response.status == 422){
            const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
            state.errors = errorData.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      }

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      state.condition = context.root.$store.state.sumupListCondition;
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.Practice);
      await search();
      state.isShow = true;
    });

    /******************************
     * 採点結果エクセルダウンロード
     ******************************/

    const downloadSaitenResult = async (sumupGroup: SumupGroup) => {
      if(!window.confirm("採点結果Excelファイルを出力します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay", "出力中。処理に数分かかる場合があります。画面を閉じずにそのままお待ちください。途中で画面を閉じると処理が中断されます。");

      state.isDispProgress = true;
      state.progress = "0.00";
      let completedCount = 0;

      for(const curriculum_id of sumupGroup.curriculum_ids){
        await http.get(`/api/teacher/practice_sumup_list/saiten_result_data/${sumupGroup.id}/${curriculum_id}`).then(async response => {
          const workbook = new ExcelJS.Workbook();

          const sheets = response.data.sheets;
          const all_examinee_hashes = response.data.all_examinee_hashes;
          const all_sheet_field_hashes = response.data.all_sheet_field_hashes;
          const all_field_activity_hashes = response.data.all_field_activity_hashes;
          const all_sheet_activity_hashes = response.data.all_sheet_activity_hashes;
          const sheet_process_ids = response.data.sheet_process_ids;

          createSheetQuestion(workbook, sheets, all_examinee_hashes, all_sheet_field_hashes, all_field_activity_hashes, all_sheet_activity_hashes, sheet_process_ids);
          createSheetPart1(workbook, sheets, all_examinee_hashes, all_sheet_field_hashes, all_field_activity_hashes, all_sheet_activity_hashes, sheet_process_ids);
          
          const uint8Array = await workbook.xlsx.writeBuffer();
          const blob = new Blob([uint8Array], { type: "application/octet-binary" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${sheets[0].name}_${context.root.$store.getters.getCurriculumNameById(curriculum_id)}.xlsx`;
          a.click();
          a.remove();

          completedCount++;
          state.progress = Number.parseFloat(`${completedCount * 100 / sumupGroup.curriculum_ids.length}`).toFixed(2);
        })
        .catch(error=>{
          if(error.response.status == 422){
            const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
            state.errors = errorData.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          state.isDispProgress = false;
          return;
        }
      }

      await resolveAfterMilliSeconds();

      alert("処理が完了しました。");
      context.root.$store.dispatch("hideOverlay");
      state.isDispProgress = false;
    }

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 1);
      });
    }

    /******************************
     * 設問別シート作成
     ******************************/

    const createSheetQuestion = (workbook: ExcelJS.Workbook, sheets: any[], all_examinee_hashes: any[], all_sheet_field_hashes: any[], all_field_activity_hashes: any[], all_sheet_activity_hashes: any[], sheet_process_ids: number[]) => {

      workbook.addWorksheet("設問別");
      const worksheet = workbook.getWorksheet("設問別");

      const sheet = sheets[0]
      
      const header = `${sheet.name}　${context.root.$store.getters.getCurriculumNameById(sheet.curriculum_id)}`;
      console.log(worksheet.getRow(1));
      worksheet.getRow(1).getCell(1).value = header;
      worksheet.getRow(2).getCell(4).value = '合計';
      worksheet.getRow(5).getCell(1).value = '教室';
      worksheet.getRow(5).getCell(2).value = '受験番号';
      worksheet.getRow(5).getCell(3).value = '氏名';

      // 試験全体の配点・平均点・得点率生成
      // 配点
      worksheet.getCell(3, 4).value = sheet.allot;

      // 平均点
      const sum_total_score = Common.sumArray(all_sheet_activity_hashes.map((sa: any) => sa.score));
      const attend_examinees_count = all_examinee_hashes.filter((x: any) => !x["absent_flg"]).length;
      worksheet.getCell(4, 4).value = `${(sum_total_score / attend_examinees_count).toFixed(1)}点`;

      // 得点率
      const sheet_total_allot = sheet.allot * attend_examinees_count
      worksheet.getCell(5, 4).value = `${((sum_total_score / sheet_total_allot) * 100).toFixed()}%`

      let sheet_field_count = 0;

      const rowNos = [...new Set(all_sheet_field_hashes.map((x: any) => x["row_no"]))]

      for(let i = 0; i < rowNos.length; i++){
        const rowNo = rowNos[i]

        const sf_group = all_sheet_field_hashes.filter((x: any) => x["row_no"] == rowNo);
        const sf = sf_group[0];
        let col_idx = i + 5;

        // 設問名
        worksheet.getCell(2, col_idx).value = sf["question"];

        // 配点
        worksheet.getCell(3, col_idx).value = sf["allot"];

        //　平均点
        const sheet_field_ids = sf_group.map((x: any) => x["id"]);
        const field_activity_hashes = all_field_activity_hashes.filter((x: any) => sheet_field_ids.includes(x["sheet_field_id"]));
        const sum_field_score = Common.sumArray(field_activity_hashes.map((fa: any) => fa["score"]));
        worksheet.getCell(4, col_idx).value = `${(sum_field_score / field_activity_hashes.length).toFixed(1)}点`

        // 得点率
        const field_total_allot = sf["allot"] * field_activity_hashes.length
        if(field_total_allot == 0){
          worksheet.getCell(5, col_idx).value = 0;
        }else{
          worksheet.getCell(5, col_idx).value = `${((sum_field_score / field_total_allot) * 100).toFixed()}%`;
        }

        sheet_field_count += 1;
      }

      let row_idx = 6;

      sheets.forEach((sheet: any, sheet_idx: number) => {
        
        const examinees = all_examinee_hashes.filter((x: any) => x["sheet_id"] == sheet["id"]).sort((a, b) => a["student_no"] - b["student_no"]);
        for(let i = 0; i < examinees.length; i++){
          
          let col_idx = 0;

          const e = examinees[i]

          // 教室
          worksheet.getCell(row_idx, 1).value = sheet.room_name;

          // 受験番号
          if(e.student_no_character){
            worksheet.getCell(row_idx, 2).value = e.student_no_character;
          }

          if(e.student_name){
            worksheet.getCell(row_idx, 3).value = e.student_name;
          }

          if(e.absent_flg){
            // 欠席生徒の場合 合計点に０、設問別得点にハイフンを設定
            worksheet.getCell(row_idx, 4).value = "-";
            for(let j = 0; j < sheet_field_count; j++){
              col_idx = j + 5
              worksheet.getCell(row_idx, col_idx).value = "-";
            }
          }else{
            // 合計点
            const sheet_activity_hashes = all_sheet_activity_hashes.filter((sa: any) => sa["student_id"] == e.student_no && sa["sheet_process_id"] == sheet_process_ids[sheet_idx])
            worksheet.getCell(row_idx, 4).value = Common.sumArray(sheet_activity_hashes.map((sa: any) => sa["score"]));

            // 設問別得点
            const sheet_activity_ids = sheet_activity_hashes.map((sa: any) => sa["id"]);
            const field_activity_hashes = all_field_activity_hashes.filter((fa: any) => sheet_activity_ids.includes(fa["sheet_activity_id"])).sort((a, b) => a["sheet_field_id"] - b["sheet_field_id"]);
            field_activity_hashes.forEach((fa: any, j: number) => {
              col_idx = j + 5;
              if(fa["score"]){
                worksheet.getCell(row_idx, col_idx).value = fa["score"];
              }else{
                worksheet.getCell(row_idx, col_idx).value = 0;
              }
            });
          }
          row_idx += 1
        }
      });
    }

    /******************************
     * 設問別シート作成
     ******************************/

    const createSheetPart1 = (workbook: ExcelJS.Workbook, sheets: any[], all_examinee_hashes: any[], all_sheet_field_hashes: any[], all_field_activity_hashes: any[], all_sheet_activity_hashes: any[], sheet_process_ids: number[]) => {

      workbook.addWorksheet("大問別");
      const worksheet = workbook.getWorksheet("大問別");

      const sheet = sheets[0]
      
      const header = `${sheet.name}　${context.root.$store.getters.getCurriculumNameById(sheet.curriculum_id)}`;
      console.log(worksheet.getRow(1));
      worksheet.getRow(1).getCell(1).value = header;
      worksheet.getRow(2).getCell(4).value = '合計';
      worksheet.getRow(5).getCell(1).value = '教室';
      worksheet.getRow(5).getCell(2).value = '受験番号';
      worksheet.getRow(5).getCell(3).value = '氏名';
    
      // 配点
      worksheet.getCell(3, 4).value = sheet.allot;

      // 平均点
      const sum_total_score = Common.sumArray(all_sheet_activity_hashes.map((sa: any) => sa["score"]));
      const attend_examinees_count = all_examinee_hashes.filter((x: any) => !x["absent_flg"]).length;
      worksheet.getCell(4, 4).value = `${(sum_total_score / attend_examinees_count).toFixed(1)}点`;

      // 得点率
      const sheet_total_allot = sheet.allot * attend_examinees_count
      worksheet.getCell(5, 4).value = `${((sum_total_score / sheet_total_allot) * 100).toFixed(0)}%`

      // 大問No抽出
      const part1s = [...new Set(all_sheet_field_hashes.map((sf: any) => sf["part1"]))].sort((a, b) => a - b);

      part1s.forEach((part1: number, i: number) => {
        let col_idx = i + 5

        // 大問Noに紐づくsheet_field取得
        const part1_sheet_field_hashes = all_sheet_field_hashes.filter((x: any) => x["part1"] == part1).sort((a, b) => a["id"] - b["id"]);

        // 大問名
        worksheet.getCell(2, col_idx).value = part1;

        // 配点
        const part1_allot = Common.sumArray(part1_sheet_field_hashes.filter((x: any) => x["sheet_id"] == sheets[0]["id"]).map((x: any) => x["allot"]));
        worksheet.getCell(3, col_idx).value = part1_allot;

        // 平均点
        const field_activity_hashes = all_field_activity_hashes.filter((fa: any) => part1_sheet_field_hashes.map((x: any) => x["id"]).includes(fa["sheet_field_id"]));
        const sum_field_score = Common.sumArray(field_activity_hashes.map((fa: any) => fa["score"]));
        worksheet.getCell(4, col_idx).value = `${(sum_field_score / attend_examinees_count).toFixed(1)}点`;

        // 得点率
        const field_total_allot = part1_allot * attend_examinees_count;
        if(field_total_allot == 0){
          worksheet.getCell(5, col_idx).value = 0;
        }else{
          worksheet.getCell(5, col_idx).value = `${((sum_field_score / field_total_allot) * 100).toFixed(0)}%`;
        }
      });

      let row_idx = 6;

      sheets.forEach((sheet: any, sheet_idx: number) => {

        const examinees = all_examinee_hashes.filter((x: any) => x["sheet_id"] == sheet["id"]).sort((a, b) => a["student_no"] - b["student_no"]);
        
        for(let i = 0; i < examinees.length; i++){
          
          let col_idx = 0;

          const e = examinees[i]

          // 教室
          worksheet.getCell(row_idx, 1).value = sheet.room_name;

          // 受験番号
          if(e.student_no_character){
            worksheet.getCell(row_idx, 2).value = e.student_no_character;
          }

          if(e.student_name){
            worksheet.getCell(row_idx, 3).value = e.student_name;
          }

          if(e.absent_flg){
            // 欠席生徒の場合 合計点に０、設問別得点にハイフンを設定
            worksheet.getCell(row_idx, 4).value = "-";
            for(let j = 0; j < part1s.length; j++){
              col_idx = j + 5
              worksheet.getCell(row_idx, col_idx).value = "-";
            }
          }else{
            // 合計点
            const sheet_activity_hashes = all_sheet_activity_hashes.filter((sa: any) => sa["student_id"] == e.student_no && sa["sheet_process_id"] == sheet_process_ids[sheet_idx])
            worksheet.getCell(row_idx, 4).value = Common.sumArray(sheet_activity_hashes.map((sa: any) => sa["score"]));

            // 大問別得点
            part1s.forEach((part1: number, j: number) => {
              col_idx = j + 5;

              // 大問Noに紐づくsheet_field取得
              const part1_sheet_field_hashes = all_sheet_field_hashes.filter((x: any) => x["part1"] == part1).sort((a, b) => a["id"] - b["id"]);

              const sheet_field_ids = [...new Set(part1_sheet_field_hashes.map((x: any) => x["id"]))];
              const sheet_activity_ids = all_sheet_activity_hashes.filter((x: any) => x["student_id"] == e.student_no && x["sheet_process_id"] == sheet_process_ids[sheet_idx]).map((x: any) => x["id"]);
              
              // sheet_fieldに紐づくfield_activity取得
              const field_activity_hashes = all_field_activity_hashes.filter((x: any) => sheet_field_ids.includes(x["sheet_field_id"]) && sheet_activity_ids.includes(x["sheet_activity_id"]));

              // field_activitiesの合計点を書き込み
              worksheet.getCell(row_idx, col_idx).value = Common.sumArray(field_activity_hashes.map((x: any) => x["score"]));
            });
          }
          row_idx += 1;
        }
      });
    }

    return {
      ...toRefs(state),
      search,
      searchClick,
      convertExecDate,
      convertSaitenCompleted,
      clearCondition,
      changePage,
      addSumupGroupClick,
      sumupEditClick,
      sumupGruoupDelete,
      sumupResultRankClick,
      sumupDetailClick,
      sumupClick,
      downloadClick,
      downloadExcelClick,
      downloadSaitenResult
    }
  }
});
